import { DateTime } from 'luxon';

export function selectByValidFrom<T extends { valid_from: string }>(
  items: T[],
  date: DateTime,
): T | undefined {
  let selected: T | undefined;
  let selectedValidFrom: DateTime | undefined;

  for (const item of items) {
    const validFrom = DateTime.fromISO(item.valid_from);

    if (validFrom.set({hour: 0}) > date.set({hour: 0})) continue;

    if (!selectedValidFrom || validFrom > selectedValidFrom) {
      selected = item;
      selectedValidFrom = validFrom;
    }
  }

  return selected;
}
